import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { PagedList } from "../modules/shared/models/api-response.model";
import { AuthService } from "./auth.service";

const API_URL = environment.api;

export interface IEmailTemplate {
    emailTemplateId: number;
    templateKey: string;
    subject: string;
    body: string;
    updatedAt: Date | null;
    type: "Email" | "SMS";
}

@Injectable()
export class EmailNotificationService {
    constructor(
        private http: HttpClient,
        private authService: AuthService
    ) {}

    getTemplate(templateId: number): Observable<IEmailTemplate> {
        return this.http
            .get<IEmailTemplate>(
                this.buildUrl(`emailNotifications/${templateId}`),
                { headers: this.createHeaders() }
            )
            .pipe(map((res) => this.mapTemplate(res)));
    }

    getPagedTemplates(
        offset: number,
        limit: number,
        sort: string | null = "+subject",
        filter: string | null = null
    ): Observable<PagedList<IEmailTemplate>> {
        const p = {} as any;

        if (limit !== -1) {
            p.offset = `${offset * limit}`;
            p.limit = limit.toString();
        }

        if (sort) {
            if (sort.charAt(0) === "+") {
                sort = sort.substr(1, sort.length);
            }

            p.sort = sort;
        }

        if (filter) {
            p.filter = filter;
        }

        const options = { headers: this.createHeaders(), params: p };

        return this.http.get(this.buildUrl("emailNotifications"), options).pipe(
            map((res: PagedList<IEmailTemplate>) => {
                res.offset = offset;
                res.data = res.data.map((n: IEmailTemplate) =>
                    this.mapTemplate(n)
                );

                return res;
            })
        );
    }

    updateTemplate(template: IEmailTemplate): Observable<IEmailTemplate> {
        const url = this.buildUrl(
            `emailNotifications/${template.emailTemplateId}`
        );

        return this.http
            .put<IEmailTemplate>(url, template, {
                headers: this.createHeaders()
            })
            .pipe(map((res) => this.mapTemplate(res)));
    }

    private buildUrl(urlFragment: string) {
        return `${API_URL}/api/v1/${urlFragment}`;
    }

    private createHeaders(): HttpHeaders {
        const h = new HttpHeaders({
            Authorization: `bearer ${this.authService.accessToken}`,
            "Content-Type": "application/json"
        });

        return h;
    }

    private mapTemplate(n: IEmailTemplate): IEmailTemplate {
        if (n.updatedAt) {
            n.updatedAt = new Date(n.updatedAt);
        }

        if (n.templateKey === "SMS-DAILY-BORROWER-POI-TEMPLATE") {
            n.type = "SMS";
        } else {
            n.type = "Email";
        }

        return n;
    }
}
